
import { Vue, Component } from "vue-property-decorator";
import { documentStore } from "@/store/store";
import { OXYGEN_BLOCK_POST_TYPE } from "@/lib/constants/post-types";

@Component({})
export default class ComponentRootTagWarning extends Vue {
  get totalRootChildren() {
    return documentStore.document.tree.root.children.length;
  }

  get isComponentType() {
    return (
      documentStore.document.documentMeta.postType === OXYGEN_BLOCK_POST_TYPE
    );
  }
}
